import VState from 'signal/v-state'

const sidebarHasBeenOpenedState = new VState(false)

export default sidebarHasBeenOpenedState